var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurkey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 335.724H8.828A8.829 8.829 0 0 1 0 326.896V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.474 137.752l13.837 18.101 21.606-7.232c1.208-.404 2.236.962 1.512 2.01l-12.939 18.753 13.555 18.314c.758 1.024-.224 2.423-1.444 2.059l-21.834-6.511-13.228 18.55c-.739 1.037-2.375.536-2.406-.737l-.555-22.777-21.73-6.849c-1.215-.383-1.244-2.092-.042-2.515l21.491-7.566-.202-22.783c-.012-1.274 1.606-1.829 2.379-.817zm-76.518 100.909c-38.995 0-70.627-31.633-70.627-70.663 0-38.958 31.633-70.662 70.627-70.662 14.508 0 27.887 4.462 39.037 12.014 1.707 1.156 3.656-1.087 2.227-2.573-16.664-17.325-40.248-27.894-66.398-27.001-44.926 1.533-82.118 37.553-84.989 82.413-3.287 51.383 37.399 94.086 88.055 94.086 24.953 0 47.379-10.432 63.393-27.112 1.415-1.473-.538-3.683-2.229-2.537-11.162 7.569-24.563 12.035-39.096 12.035z",
    fill: "#F5F5F5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/TURKEY.148bbb3a8247215d9225d92fcaa2d5ce.svg";
export { ForwardRef as ReactComponent };